/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-transfer-conversation': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M10.8 8.1v2.127c0 .655.736.982 1.227.573l5.646-4.5c.409-.327.409-.9 0-1.145l-5.646-4.5a.742.742 0 00-1.227.572v2.21C5.89 3.763 2.945 6.79 2.945 10.8c0 .9.164 1.718.41 2.536C4.255 10.8 7.773 8.51 10.8 8.1zm6.382.41c-.491 0-.818.326-.818.817v6.382c0 .082 0 .082-.082.082H1.718c-.082 0-.082 0-.082-.082V9.327a.82.82 0 00-.818-.818c-.49 0-.818.327-.818.818v7.282c0 .41.327.818.818.818h16.364c.49 0 .818-.327.818-.818V9.327c0-.49-.327-.818-.818-.818z" _fill="#B4B4B4"/>'
  }
})
